import { cn } from "@/util/functions";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

const EditableCell = ({
  getValue,
  row,
  column,
  table,
  fieldName,
  fieldType = "string",
  inputClass = "",
  converter,
}) => {
  const columnMeta = column.columnDef.meta;
  const tableMeta = table.options.meta;
  let initialValue;
  if (fieldName) initialValue = getValue()[fieldName];
  else initialValue = getValue();
  if (converter) initialValue = converter(initialValue);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onBlur = () => {
    table.options.meta?.updateData(
      row.index,
      column.id,
      row.original.id,
      fieldName,
      value
    );
  };

  const onSelectChange = (e) => {
    let newValue =
      fieldType === "number"
        ? e.target.value === "None"
          ? null
          : Number(e.target.value)
        : e.target.value;
    setValue(newValue);
    tableMeta?.updateData(
      row.index,
      column.id,
      row.original.id,
      fieldName,
      newValue
    );
  };

  if (Number(tableMeta?.editingId) === Number(row.original.id)) {
    return (
      <>
        {(columnMeta?.type === "text" || columnMeta?.type === "number") && (
          <input
            className={cn("editable-cell-input", inputClass)}
            value={value}
            type={columnMeta?.type}
            onChange={(e) => setValue(e.target.value)}
            onBlur={onBlur}
          />
        )}
        {columnMeta?.type === "select" && (
          <Form.Select
            value={value}
            onChange={onSelectChange}
            style={{ width: 150, paddingTop: "0px", paddingBottom: "0px" }}
          >
            {columnMeta?.options?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        )}
      </>
    );
  }
  return (
    <span>
      {columnMeta?.type === "select"
        ? columnMeta.options?.find(
            ({ value: optionVal }) => String(optionVal) === String(value)
          )?.label
        : value}
    </span>
  );
};

export default EditableCell;
